import { getCurationContentCentres } from '../../../helpers/curation-storefront'
import { FulfilmentCentre } from '../../../redux-toolkits/fulfilment-centres/fulfilmentCentres.type'
import { useState } from 'react'
import ModalComponent from '..'
import { useFetchListMenusQuery } from '../../../redux-toolkits/list-menu/listMenu.slice'
import { ListMenuItem } from '../../../redux-toolkits/list-menu/listMenu.types'
import { Button } from '../../button'
import { Checkbox } from '../../inputs/Checkbox'
import { SearchInput } from '../../inputs/searchInput'

export const SelectListMenuModal = ({
  selectedMenus,
  fulfilmentCentre,
  onClose,
  onSave,
}: {
  selectedMenus: ListMenuItem[]
  fulfilmentCentre?: FulfilmentCentre
  onClose: () => void
  onSave: (menus: ListMenuItem[]) => void
}) => {
  const contentCentres = getCurationContentCentres(
    fulfilmentCentre ? [fulfilmentCentre] : undefined,
  )
  const fulfilmentCentreId = contentCentres?.[0]?._id
  const [selected, setSelected] = useState(selectedMenus)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const {
    currentData: data,
    isFetching,
    isError,
    refetch,
  } = useFetchListMenusQuery(
    {
      page,
      limit: 20,
      search: search || undefined,
      isActive: true,
      fulfilmentCentreId,
    },
    { skip: !fulfilmentCentre, refetchOnMountOrArgChange: true },
  )

  return (
    <ModalComponent
      open
      setOpen={(open) => !open && onClose()}
      title="Select list menus"
      childrenClassName="md:!max-w-[600px]"
    >
      <div className="flex max-h-[620px] flex-col gap-4">
        <p className="text-sm text-sec-black">
          Choose published menus for this homepage. Parent storefronts can
          select across centres; child storefronts show their own menus. Counts
          include published lists only.
        </p>
        <a
          className="text-sm underline"
          href="/channel-curation/nav-menu/new"
          target="_blank"
          rel="noreferrer"
        >
          Create a list menu
        </a>
        <SearchInput
          placeholder="Search list menus"
          className="!max-w-full"
          searchFunction={(value) => {
            setSearch(value)
            setPage(1)
          }}
        />
        <div className="flex-1 space-y-2 overflow-y-auto">
          {!fulfilmentCentre ? (
            <p>Select a storefront first.</p>
          ) : isFetching ? (
            <p className="py-8 text-center text-sm">Loading list menus…</p>
          ) : isError ? (
            <div role="alert">
              <p>Unable to load list menus.</p>
              <Button label="Retry" onClick={() => refetch()} />
            </div>
          ) : !data?.data.docs.length ? (
            <p className="py-8 text-center text-sm">
              No published list menus found for this storefront.
            </p>
          ) : (
            data.data.docs.map((menu) => {
              const checked = selected.some((item) => item._id === menu._id)
              return (
                <Checkbox
                  key={menu._id}
                  checkStatus={checked}
                  disabled={!checked && selected.length >= 12}
                  className="w-full border-b py-3 last:border-b-0"
                  handleChange={(isChecked) =>
                    setSelected((current) =>
                      isChecked
                        ? [...current, menu]
                        : current.filter((item) => item._id !== menu._id),
                    )
                  }
                  text={
                    <div className="flex items-center gap-3">
                      {menu.banner ? (
                        <img
                          alt=""
                          src={menu.banner}
                          className="h-16 w-24 rounded-lg object-cover"
                        />
                      ) : null}
                      <div>
                        <p className="font-medium">{menu.name}</p>
                        <p className="text-xs text-sec-black line-clamp-2">
                          {menu.description}
                        </p>
                        <p className="text-xs text-sec-black">
                          {menu.listCount} published{' '}
                          {menu.listCount === 1 ? 'list' : 'lists'}
                        </p>
                      </div>
                    </div>
                  }
                />
              )
            })
          )}
        </div>
        <div className="flex items-center justify-between gap-3">
          <Button
            label="Previous"
            variant="border-grey"
            disabled={page === 1 || isFetching}
            onClick={() => setPage(page - 1)}
          />
          <span className="text-sm">Page {page}</span>
          <Button
            label="Next"
            variant="border-grey"
            disabled={!data?.data.hasNextPage || isFetching}
            onClick={() => setPage(page + 1)}
          />
        </div>
        <Button
          label={`Use selected menus (${selected.length})`}
          primary
          disabled={!fulfilmentCentre}
          onClick={() => onSave(selected)}
        />
      </div>
    </ModalComponent>
  )
}
